import z from 'zod';
export const libraryDocumentIdValue = z.string().trim().min(1)
    .brand('LibraryDocumentId');
export const createLibraryDocumentId = (value) => libraryDocumentIdValue.parse(value);
export const isLibraryDocumentId = (value) => libraryDocumentIdValue.safeParse(value).success;
export const editorDraftIdValue = z.string().trim().min(1)
    .brand('EditorDraftId');
export const createEditorDraftId = (value) => editorDraftIdValue.parse(value);
export const isEditorDraftId = (value) => editorDraftIdValue.safeParse(value).success;
//# sourceMappingURL=ids.js.map